import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Select, Card, Spin, message, Row, Col } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { fetchSucursales, selectSucursal } from '../../redux/sucursal/actionCreator';
import { Main } from '../styled';
import './style.css';

const { Option } = Select;

const SucursalSelector = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { list, loading, error } = useSelector((state) => state.sucursal);
  const user = useSelector((state) => state.auth.login?.user);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    // Si el usuario tiene sucursal asignada, redirigir directamente
    if (user?.sucursalAsignada) {
      history.replace('/admin');
      return;
    }

    // Si no es admin, redirigir
    if (user?.role !== 'admin') {
      history.replace('/admin');
      return;
    }

    // Cargar lista de sucursales
    dispatch(fetchSucursales()).catch((err) => {
      message.error('Error al cargar sucursales');
      console.error(err);
    });
  }, [dispatch, user, history]);

  const handleSelect = (sucursalId) => {
    const sucursal = list.find((s) => s.id === sucursalId);
    if (sucursal) {
      setSelectedId(sucursalId);
      dispatch(selectSucursal(sucursal));
      message.success(`Sucursal ${sucursal.nombre} seleccionada`);
      setTimeout(() => {
        history.replace('/admin');
      }, 500);
    }
  };

  if (loading) {
    return (
      <Main>
        <div className="sucursal-selector-loading">
          <Spin size="large" tip="Cargando sucursales..." />
        </div>
      </Main>
    );
  }

  if (error) {
    return (
      <Main>
        <div className="sucursal-selector-error">
          <Card>
            <p>Error: {error}</p>
          </Card>
        </div>
      </Main>
    );
  }

  return (
    <Main>
      <Row justify="center" align="middle" style={{ minHeight: '80vh' }}>
        <Col xs={24} sm={20} md={16} lg={12} xl={8}>
          <Card 
            title={
              <div style={{ textAlign: 'center' }}>
                <ShopOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '16px' }} />
                <h2>Selecciona una Sucursal</h2>
              </div>
            }
            style={{ textAlign: 'center' }}
          >
            <p style={{ marginBottom: '24px', color: '#666' }}>
              Elige la sucursal con la que deseas trabajar
            </p>
            <Select
              style={{ width: '100%' }}
              placeholder="Selecciona una sucursal"
              onChange={handleSelect}
              value={selectedId}
              size="large"
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {list.map((sucursal) => (
                <Option key={sucursal.id} value={sucursal.id}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>{sucursal.nombre}</span>
                    <span style={{ color: '#999', fontSize: '12px' }}>{sucursal.codigo}</span>
                  </div>
                </Option>
              ))}
            </Select>
            {list.length === 0 && !loading && (
              <p style={{ marginTop: '16px', color: '#999' }}>
                No hay sucursales disponibles
              </p>
            )}
          </Card>
        </Col>
      </Row>
    </Main>
  );
};

export default SucursalSelector;
